import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CollectionPopup from '../collection_popup';
import {trackEvent, trackTime} from '../../../utils/tracking.js';
import { withGigCardContext } from '../../gig_card_context';
import '@fiverr/i18n/singleton';
import './style.scss';

class CollectionMenu extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            showPopup: false
        };

        this.togglePopup = this.togglePopup.bind(this);
        this.onCollectionClicked = this.onCollectionClicked.bind(this);
        this.startTime = Date.now();
    }

    componentDidMount() {
        trackTime('collection-menu-component-did-mount', this.startTime, this.props.cardType);
    }

    componentWillUnmount() {
        trackTime('collect-menu-component-will-unmount', this.startTime, this.props.cardType);
    }

    togglePopup(e) {
        e.preventDefault();

        this.setState({
            showPopup: !this.state.showPopup
        });

        this.state.showPopup && trackEvent('collections_list-open', this.props.cardType, this.props.cardSize);
    }

    onCollectionClicked(e, coll, isCollected) {
        const payload = {
            collection: {
                type: 'gig',
                source: 'gig_card',
                name: coll
            },
            user: {
                id: this.props.user.id
            },
            seller: {
                id: this.props.sellerId
            },
            gig: {
                id: this.props.gigId
            }

        };

        trackEvent(`collections_list-${!isCollected ? 'collected' : 'uncollected'}`, this.props.cardType, this.props.cardSize);
        trackEvent(`collections_list.${!isCollected ? 'create' : 'destroy'}`, this.props.cardType, this.props.cardSize, 'click', payload, 'bigquery');

        this.props.toggleCollection(e, coll, isCollected);
    }

    render() {
        const { gigId, cardType, cardSize, saveCollection, collections, sellerId } = this.props,
            {showPopup} = this.state,
            collectionsList = collections.collections || {},
            collKeys = Object.keys(collectionsList);

        return (
            <div className="gig-fav-menu">
                <div className="collection-dd coll-dd-4gig open" data-gig-id={gigId}>
                    <div className="antiscroll-wrap">
                        <ul className="antiscroll-inner coll-dd-list">
                            {collKeys.length && collKeys.map((coll) => {
                                const isCollected = collectionsList[coll].gigs.includes(gigId);
                                return (<li className="coll-dd-item" key={coll}>
                                    <a href="#"
                                        className={`heart${isCollected ? ' collected' : ''}`}
                                        onClick={(e) => this.onCollectionClicked(e, coll, isCollected)}>
                                        {coll}
                                    </a>
                                </li>);
                            })}
                        </ul>
                    </div>
                    <ul>
                        <li className="divider"></li>
                        <li>
                            <a href="#!"
                                className="add-coll"
                                onClick={(e) => this.togglePopup(e)}>
                                {i18n.t('collections.add_collection')}
                            </a>
                        </li>
                    </ul>
                </div>
                {showPopup && <CollectionPopup gigId={gigId} sellerId={sellerId} saveCollection={saveCollection} popupCallback={this.togglePopup} cardType={cardType} cardSize={cardSize}/>}
            </div>
        );
    }
}

CollectionMenu.propTypes = {
    gigId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    collections: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
    cardType: PropTypes.string,
    saveCollection: PropTypes.func,
    toggleCollection: PropTypes.func
};

const contextSelector = ({ user }) => ({ user });

export {CollectionMenu as UnwrappedCollectionMenu};

export default withGigCardContext(contextSelector)(CollectionMenu);



// WEBPACK FOOTER //
// ./src/shared/collect_gig/collection_menu/index.js